// import React, {
//   ChangeEvent,
//   FormEvent,
//   useEffect,
//   useState,
// } from "react";

// import {
//   ExternalLink,
//   Image as ImageIcon,
//   Link as LinkIcon,
//   Loader2,
//   Pencil,
//   Plus,
//   RefreshCw,
//   Trash2,
//   Upload,
//   X,
// } from "lucide-react";

// // ============================================================
// // TYPES
// // ============================================================

// interface CorporateTrainingSession {
//   _id: string;
//   image: string;
//   link: string;
// }

// interface CorporateTrainingForm {
//   image: string;
//   link: string;
// }

// // ============================================================
// // API
// // ============================================================

// const UPLOAD_API =
//   "https://service.ireedindia.com/upload";

// const IMAGE_BASE_URL =
//   "https://service.ireedindia.com/image/";

// const API_BASE =
//   "https://service.ireedindia.com/v1/corporate-training";

// // ============================================================
// // HELPER
// // ============================================================

// const getImageUrl = (
//   image: string
// ): string => {
//   if (!image) {
//     return "";
//   }

//   if (
//     image.startsWith("http://") ||
//     image.startsWith("https://") ||
//     image.startsWith("blob:")
//   ) {
//     return image;
//   }

//   return `${IMAGE_BASE_URL}${image.replace(
//     /^\/+/,
//     ""
//   )}`;
// };

// // ============================================================
// // EXTRACT IMAGE FROM UPLOAD RESPONSE
// // ============================================================

// const extractUploadedImage = (
//   data: unknown
// ): string | null => {
//   if (!data) {
//     return null;
//   }

//   // ----------------------------------------------------------
//   // String response
//   // ----------------------------------------------------------

//   if (typeof data === "string") {
//     const value = data.trim();

//     if (!value) {
//       return null;
//     }

//     // Full URL
//     if (
//       value.startsWith("http://") ||
//       value.startsWith("https://")
//     ) {
//       return value;
//     }

//     // Ignore generic messages
//     const genericMessages = [
//       "success",
//       "uploaded successfully",
//       "file uploaded successfully",
//       "upload successful",
//       "ok",
//     ];

//     if (
//       genericMessages.some(
//         (message) =>
//           value.toLowerCase() ===
//           message.toLowerCase()
//       )
//     ) {
//       return null;
//     }

//     return getImageUrl(value);
//   }

//   // ----------------------------------------------------------
//   // Object response
//   // ----------------------------------------------------------

//   if (
//     typeof data === "object" &&
//     data !== null
//   ) {
//     const object =
//       data as Record<string, unknown>;

//     // Most likely keys
//     const directKeys = [
//       "url",
//       "image",
//       "imageUrl",
//       "imageURL",
//       "fileUrl",
//       "fileURL",
//       "path",
//       "filePath",
//       "file",
//       "filename",
//       "fileName",
//       "location",
//       "imagePath",
//       "imageName",
//       "uploadedFile",
//     ];

//     for (const key of directKeys) {
//       const value = object[key];

//       if (typeof value === "string") {
//         const trimmed = value.trim();

//         if (!trimmed) {
//           continue;
//         }

//         if (
//           trimmed.startsWith(
//             "http://"
//           ) ||
//           trimmed.startsWith(
//             "https://"
//           )
//         ) {
//           return trimmed;
//         }

//         /*
//          * Don't treat generic API messages
//          * as image paths.
//          */

//         if (
//           trimmed.toLowerCase() ===
//             "success" ||
//           trimmed
//             .toLowerCase()
//             .includes(
//               "successfully"
//             )
//         ) {
//           continue;
//         }

//         return getImageUrl(trimmed);
//       }
//     }

//     // --------------------------------------------------------
//     // Nested data
//     // --------------------------------------------------------

//     const nestedKeys = [
//       "data",
//       "result",
//       "response",
//       "fileData",
//       "uploaded",
//     ];

//     for (const key of nestedKeys) {
//       const nested = object[key];

//       const result =
//         extractUploadedImage(
//           nested
//         );

//       if (result) {
//         return result;
//       }
//     }

//     // --------------------------------------------------------
//     // Search recursively
//     // --------------------------------------------------------

//     for (const value of Object.values(
//       object
//     )) {
//       if (
//         typeof value === "object" &&
//         value !== null
//       ) {
//         const result =
//           extractUploadedImage(
//             value
//           );

//         if (result) {
//           return result;
//         }
//       }
//     }
//   }

//   return null;
// };

// // ============================================================
// // COMPONENT
// // ============================================================

// export default function CorporateTraning() {
//   // ==========================================================
//   // CREATE FORM
//   // ==========================================================

//   const [form, setForm] =
//     useState<CorporateTrainingForm>({
//       image: "",
//       link: "",
//     });

//   const [selectedFile, setSelectedFile] =
//     useState<File | null>(null);

//   const [previewUrl, setPreviewUrl] =
//     useState("");

//   // ==========================================================
//   // SESSIONS
//   // ==========================================================

//   const [sessions, setSessions] = useState<
//     CorporateTrainingSession[]
//   >([]);

//   // ==========================================================
//   // EDIT
//   // ==========================================================

//   const [editingSession, setEditingSession] =
//     useState<CorporateTrainingSession | null>(
//       null
//     );

//   const [isModalOpen, setIsModalOpen] =
//     useState(false);

//   // ==========================================================
//   // LOADING
//   // ==========================================================

//   const [loading, setLoading] =
//     useState(false);

//   const [fetching, setFetching] =
//     useState(false);

//   const [uploading, setUploading] =
//     useState(false);

//   const [deleteId, setDeleteId] =
//     useState<string | null>(null);

//   // ==========================================================
//   // MESSAGE
//   // ==========================================================

//   const [error, setError] =
//     useState("");

//   const [success, setSuccess] =
//     useState("");

//   // ==========================================================
//   // GET ALL
//   // ==========================================================

//   const fetchSessions = async () => {
//     try {
//       setFetching(true);
//       setError("");

//       const response = await fetch(
//         `${API_BASE}/find-all`
//       );

//       const responseText =
//         await response.text();

//       console.log(
//         "FIND ALL STATUS:",
//         response.status
//       );

//       console.log(
//         "FIND ALL RESPONSE:",
//         responseText
//       );

//       if (!response.ok) {
//         throw new Error(
//           `Failed to fetch sessions. Status: ${response.status}`
//         );
//       }

//       let data: unknown;

//       try {
//         data = JSON.parse(
//           responseText
//         );
//       } catch {
//         data = responseText;
//       }

//       let list: CorporateTrainingSession[] =
//         [];

//       // Direct array
//       if (Array.isArray(data)) {
//         list =
//           data as CorporateTrainingSession[];
//       }

//       // Object
//       else if (
//         typeof data === "object" &&
//         data !== null
//       ) {
//         const object =
//           data as Record<
//             string,
//             unknown
//           >;

//         const possibleLists = [
//           object.data,
//           object.sessions,
//           object.content,
//           object.results,
//         ];

//         for (const possibleList of possibleLists) {
//           if (
//             Array.isArray(
//               possibleList
//             )
//           ) {
//             list =
//               possibleList as CorporateTrainingSession[];

//             break;
//           }
//         }
//       }

//       setSessions(list);
//     } catch (err) {
//       console.error(
//         "FETCH SESSIONS ERROR:",
//         err
//       );

//       setError(
//         err instanceof Error
//           ? err.message
//           : "Unable to load training sessions."
//       );
//     } finally {
//       setFetching(false);
//     }
//   };

//   // ==========================================================
//   // INITIAL LOAD
//   // ==========================================================

//   useEffect(() => {
//     fetchSessions();
//   }, []);

//   // ==========================================================
//   // UPLOAD IMAGE
//   // ==========================================================

//   const uploadImage = async (
//     file: File
//   ): Promise<string> => {
//     const formData =
//       new FormData();

//     formData.append(
//       "file",
//       file
//     );

//     console.log(
//       "UPLOADING FILE:",
//       file.name
//     );

//     const response = await fetch(
//       UPLOAD_API,
//       {
//         method: "POST",
//         body: formData,
//       }
//     );

//     const responseText =
//       await response.text();

//     console.log(
//       "UPLOAD STATUS:",
//       response.status
//     );

//     console.log(
//       "UPLOAD RAW RESPONSE:",
//       responseText
//     );

//     if (!response.ok) {
//       throw new Error(
//         `Image upload failed. Status: ${response.status}`
//       );
//     }

//     let data: unknown;

//     try {
//       data = JSON.parse(
//         responseText
//       );
//     } catch {
//       data = responseText;
//     }

//     console.log(
//       "UPLOAD PARSED RESPONSE:",
//       data
//     );

//     const uploadedImage =
//       extractUploadedImage(data);

//     console.log(
//       "EXTRACTED IMAGE:",
//       uploadedImage
//     );

//     if (!uploadedImage) {
//       throw new Error(
//         "Image uploaded successfully, but the API did not return an image path/URL."
//       );
//     }

//     return uploadedImage;
//   };

//   // ==========================================================
//   // CREATE IMAGE SELECT
//   // ==========================================================

//   const handleFileChange = async (
//     event: ChangeEvent<HTMLInputElement>
//   ) => {
//     const file =
//       event.target.files?.[0];

//     if (!file) {
//       return;
//     }

//     setError("");
//     setSuccess("");

//     if (
//       !file.type.startsWith(
//         "image/"
//       )
//     ) {
//       setError(
//         "Please select a valid image file."
//       );

//       event.target.value = "";

//       return;
//     }

//     if (
//       file.size >
//       5 * 1024 * 1024
//     ) {
//       setError(
//         "Image size must be less than 5MB."
//       );

//       event.target.value = "";

//       return;
//     }

//     setSelectedFile(file);

//     // --------------------------------------------------------
//     // Instant local preview
//     // --------------------------------------------------------

//     const localPreview =
//       URL.createObjectURL(file);

//     setPreviewUrl(localPreview);

//     try {
//       setUploading(true);

//       const imageUrl =
//         await uploadImage(file);

//       console.log(
//         "FINAL IMAGE URL:",
//         imageUrl
//       );

//       setForm(
//         (
//           prev: CorporateTrainingForm
//         ) => ({
//           ...prev,
//           image: imageUrl,
//         })
//       );

//       setSuccess(
//         "Image uploaded successfully."
//       );
//     } catch (err) {
//       console.error(
//         "IMAGE UPLOAD ERROR:",
//         err
//       );

//       setForm(
//         (
//           prev: CorporateTrainingForm
//         ) => ({
//           ...prev,
//           image: "",
//         })
//       );

//       setError(
//         err instanceof Error
//           ? err.message
//           : "Unable to upload image."
//       );
//     } finally {
//       setUploading(false);
//     }
//   };

//   // ==========================================================
//   // CREATE SESSION
//   // ==========================================================

//   const handleCreate = async (
//     event: FormEvent<HTMLFormElement>
//   ) => {
//     event.preventDefault();

//     setError("");
//     setSuccess("");

//     console.log(
//       "CREATE FORM:",
//       form
//     );

//     // --------------------------------------------------------
//     // Validation
//     // --------------------------------------------------------

//     if (!form.image) {
//       setError(
//         "Please upload an image and wait for the upload to finish."
//       );

//       return;
//     }

//     if (!form.link.trim()) {
//       setError(
//         "Please enter a registration link."
//       );

//       return;
//     }

//     try {
//       setLoading(true);

//       const payload = {
//         image: form.image,
//         link: form.link.trim(),
//       };

//       console.log(
//         "CREATE PAYLOAD:",
//         payload
//       );

//       const response = await fetch(
//         `${API_BASE}/create`,
//         {
//           method: "POST",
//           headers: {
//             "Content-Type":
//               "application/json",
//           },
//           body: JSON.stringify(
//             payload
//           ),
//         }
//       );

//       const responseText =
//         await response.text();

//       console.log(
//         "CREATE STATUS:",
//         response.status
//       );

//       console.log(
//         "CREATE RESPONSE:",
//         responseText
//       );

//       let data: unknown;

//       try {
//         data = JSON.parse(
//           responseText
//         );
//       } catch {
//         data = responseText;
//       }

//       if (!response.ok) {
//         let apiMessage = "";

//         if (
//           typeof data ===
//             "object" &&
//           data !== null
//         ) {
//           const object =
//             data as Record<
//               string,
//               unknown
//             >;

//           if (
//             typeof object.message ===
//             "string"
//           ) {
//             apiMessage =
//               object.message;
//           }

//           if (
//             typeof object.error ===
//             "string"
//           ) {
//             apiMessage =
//               object.error;
//           }
//         }

//         throw new Error(
//           apiMessage ||
//             `Create failed with status ${response.status}`
//         );
//       }

//       setSuccess(
//         "Corporate training session created successfully."
//       );

//       // Reset
//       setForm({
//         image: "",
//         link: "",
//       });

//       setSelectedFile(null);
//       setPreviewUrl("");

//       // Refresh
//       await fetchSessions();
//     } catch (err) {
//       console.error(
//         "CREATE SESSION ERROR:",
//         err
//       );

//       setError(
//         err instanceof Error
//           ? err.message
//           : "Unable to create training session."
//       );
//     } finally {
//       setLoading(false);
//     }
//   };

//   // ==========================================================
//   // OPEN EDIT
//   // ==========================================================

//   const openEditModal = (
//     session: CorporateTrainingSession
//   ) => {
//     setEditingSession({
//       ...session,
//       image: session.image,
//     });

//     setError("");
//     setSuccess("");
//     setIsModalOpen(true);
//   };

//   // ==========================================================
//   // CLOSE EDIT
//   // ==========================================================

//   const closeEditModal = () => {
//     setEditingSession(null);
//     setIsModalOpen(false);
//   };

//   // ==========================================================
//   // EDIT IMAGE
//   // ==========================================================

//   const handleEditFileChange =
//     async (
//       event: ChangeEvent<HTMLInputElement>
//     ) => {
//       const file =
//         event.target.files?.[0];

//       if (
//         !file ||
//         !editingSession
//       ) {
//         return;
//       }

//       setError("");
//       setSuccess("");

//       if (
//         !file.type.startsWith(
//           "image/"
//         )
//       ) {
//         setError(
//           "Please select a valid image."
//         );

//         event.target.value = "";

//         return;
//       }

//       if (
//         file.size >
//         5 * 1024 * 1024
//       ) {
//         setError(
//           "Image size must be less than 5MB."
//         );

//         event.target.value = "";

//         return;
//       }

//       try {
//         setUploading(true);

//         const imageUrl =
//           await uploadImage(file);

//         console.log(
//           "EDIT IMAGE URL:",
//           imageUrl
//         );

//         setEditingSession(
//           (
//             prev: CorporateTrainingSession | null
//           ) =>
//             prev
//               ? {
//                   ...prev,
//                   image: imageUrl,
//                 }
//               : null
//         );

//         setSuccess(
//           "New image uploaded successfully."
//         );
//       } catch (err) {
//         console.error(
//           "EDIT IMAGE ERROR:",
//           err
//         );

//         setError(
//           err instanceof Error
//             ? err.message
//             : "Unable to upload new image."
//         );
//       } finally {
//         setUploading(false);
//       }
//     };

//   // ==========================================================
//   // UPDATE
//   // ==========================================================

//   const handleUpdate = async (
//     event: FormEvent<HTMLFormElement>
//   ) => {
//     event.preventDefault();

//     if (!editingSession) {
//       return;
//     }

//     setError("");
//     setSuccess("");

//     if (!editingSession.image) {
//       setError(
//         "Please upload an image."
//       );

//       return;
//     }

//     if (
//       !editingSession.link.trim()
//     ) {
//       setError(
//         "Please enter a registration link."
//       );

//       return;
//     }

//     try {
//       setLoading(true);

//       const payload = {
//         image:
//           editingSession.image,
//         link:
//           editingSession.link.trim(),
//       };

//       console.log(
//         "UPDATE PAYLOAD:",
//         payload
//       );

//       const response = await fetch(
//         `${API_BASE}/edit/${editingSession._id}`,
//         {
//           method: "PATCH",
//           headers: {
//             "Content-Type":
//               "application/json",
//           },
//           body: JSON.stringify(
//             payload
//           ),
//         }
//       );

//       const responseText =
//         await response.text();

//       console.log(
//         "UPDATE STATUS:",
//         response.status
//       );

//       console.log(
//         "UPDATE RESPONSE:",
//         responseText
//       );

//       let data: unknown;

//       try {
//         data = JSON.parse(
//           responseText
//         );
//       } catch {
//         data = responseText;
//       }

//       if (!response.ok) {
//         let message = "";

//         if (
//           typeof data ===
//             "object" &&
//           data !== null
//         ) {
//           const object =
//             data as Record<
//               string,
//               unknown
//             >;

//           if (
//             typeof object.message ===
//             "string"
//           ) {
//             message =
//               object.message;
//           }

//           if (
//             typeof object.error ===
//             "string"
//           ) {
//             message =
//               object.error;
//           }
//         }

//         throw new Error(
//           message ||
//             `Update failed with status ${response.status}`
//         );
//       }

//       closeEditModal();

//       setSuccess(
//         "Training session updated successfully."
//       );

//       await fetchSessions();
//     } catch (err) {
//       console.error(
//         "UPDATE ERROR:",
//         err
//       );

//       setError(
//         err instanceof Error
//           ? err.message
//           : "Unable to update training session."
//       );
//     } finally {
//       setLoading(false);
//     }
//   };

//   // ==========================================================
//   // DELETE
//   // ==========================================================

//   const handleDelete = async (
//     id: string
//   ) => {
//     const confirmed =
//       window.confirm(
//         "Are you sure you want to delete this training session?"
//       );

//     if (!confirmed) {
//       return;
//     }

//     try {
//       setDeleteId(id);
//       setError("");
//       setSuccess("");

//       const response = await fetch(
//         `${API_BASE}/delete/${id}`,
//         {
//           method: "DELETE",
//         }
//       );

//       const responseText =
//         await response.text();

//       console.log(
//         "DELETE STATUS:",
//         response.status
//       );

//       console.log(
//         "DELETE RESPONSE:",
//         responseText
//       );

//       if (!response.ok) {
//         throw new Error(
//           `Delete failed with status ${response.status}`
//         );
//       }

//       setSuccess(
//         "Training session deleted successfully."
//       );

//       await fetchSessions();
//     } catch (err) {
//       console.error(
//         "DELETE ERROR:",
//         err
//       );

//       setError(
//         err instanceof Error
//           ? err.message
//           : "Unable to delete training session."
//       );
//     } finally {
//       setDeleteId(null);
//     }
//   };

//   // ==========================================================
//   // RENDER
//   // ==========================================================

//   return (
//     <div className="min-h-screen bg-slate-50 p-4 sm:p-6 lg:p-8">

//       <div className="mx-auto max-w-7xl">

//         {/* ====================================================
//             HEADER
//         ==================================================== */}

//         <div className="mb-8 flex flex-col gap-4 md:flex-row md:items-center md:justify-between">

//           <div>

//             <div className="mb-2 flex items-center gap-2">

//               <div className="h-2 w-2 rounded-full bg-blue-600" />

//               <p className="text-sm font-semibold uppercase tracking-wider text-blue-600">
//                 Dashboard
//               </p>

//             </div>

//             <h1 className="text-2xl font-bold tracking-tight text-slate-900 sm:text-3xl">
//               Corporate Training
//             </h1>

//             <p className="mt-1 text-sm text-slate-500">
//               Create and manage corporate training sessions.
//             </p>

//           </div>

//           <button
//             type="button"
//             onClick={fetchSessions}
//             disabled={fetching}
//             className="inline-flex h-11 items-center justify-center gap-2 rounded-xl border border-slate-200 bg-white px-4 text-sm font-medium text-slate-700 shadow-sm transition hover:bg-slate-50 disabled:cursor-not-allowed disabled:opacity-60"
//           >

//             <RefreshCw
//               size={17}
//               className={
//                 fetching
//                   ? "animate-spin"
//                   : ""
//               }
//             />

//             Refresh

//           </button>

//         </div>

//         {/* ====================================================
//             ERROR
//         ==================================================== */}

//         {error && (
//           <div className="mb-5 flex items-start justify-between gap-4 rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">

//             <div className="leading-6">
//               {error}
//             </div>

//             <button
//               type="button"
//               onClick={() =>
//                 setError("")
//               }
//               className="shrink-0 rounded-md p-1 hover:bg-red-100"
//             >
//               <X size={18} />
//             </button>

//           </div>
//         )}

//         {/* ====================================================
//             SUCCESS
//         ==================================================== */}

//         {success && (
//           <div className="mb-5 flex items-start justify-between gap-4 rounded-xl border border-emerald-200 bg-emerald-50 px-4 py-3 text-sm text-emerald-700">

//             <div className="leading-6">
//               {success}
//             </div>

//             <button
//               type="button"
//               onClick={() =>
//                 setSuccess("")
//               }
//               className="shrink-0 rounded-md p-1 hover:bg-emerald-100"
//             >
//               <X size={18} />
//             </button>

//           </div>
//         )}

//         {/* ====================================================
//             ADD TRAINING
//         ==================================================== */}

//         <div className="mb-8 overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm">

//           {/* Header */}

//           <div className="border-b border-slate-100 px-5 py-5 sm:px-7">

//             <div className="flex items-center gap-3">

//               <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-blue-50 text-blue-600">

//                 <Plus size={21} />

//               </div>

//               <div>

//                 <h2 className="font-semibold text-slate-900">
//                   Add Training Session
//                 </h2>

//                 <p className="mt-0.5 text-sm text-slate-500">
//                   Add an image and registration link.
//                 </p>

//               </div>

//             </div>

//           </div>

//           {/* Form */}

//           <form
//             onSubmit={handleCreate}
//             className="grid gap-7 p-5 sm:p-7 lg:grid-cols-2"
//           >

//             {/* ==================================================
//                 IMAGE
//             ================================================== */}

//             <div>

//               <label className="mb-2 block text-sm font-semibold text-slate-700">
//                 Training Image
//               </label>

//               <label className="group relative flex min-h-[280px] cursor-pointer flex-col items-center justify-center overflow-hidden rounded-2xl border-2 border-dashed border-slate-200 bg-slate-50 transition hover:border-blue-400">

//                 {previewUrl ||
//                 form.image ? (
//                   <>
//                     <img
//                       src={
//                         previewUrl ||
//                         getImageUrl(
//                           form.image
//                         )
//                       }
//                       alt="Training preview"
//                       className="absolute inset-0 h-full w-full object-cover"
//                       onError={(
//                         event
//                       ) => {
//                         console.error(
//                           "IMAGE PREVIEW ERROR:",
//                           form.image
//                         );

//                         event.currentTarget.style.display =
//                           "none";
//                       }}
//                     />

//                     {/* Overlay */}

//                     <div className="absolute inset-0 flex items-center justify-center bg-black/50 opacity-0 transition group-hover:opacity-100">

//                       <div className="flex items-center gap-2 rounded-xl bg-white px-5 py-3 text-sm font-semibold text-slate-800 shadow-lg">

//                         <Upload
//                           size={17}
//                         />

//                         Change Image

//                       </div>

//                     </div>

//                     {/* Uploading */}

//                     {uploading && (
//                       <div className="absolute inset-0 flex items-center justify-center bg-black/50">

//                         <div className="flex items-center gap-2 rounded-xl bg-white px-5 py-3 text-sm font-semibold text-slate-800">

//                           <Loader2
//                             size={18}
//                             className="animate-spin"
//                           />

//                           Uploading...

//                         </div>

//                       </div>
//                     )}
//                   </>
//                 ) : (
//                   <>
//                     <div className="mb-4 flex h-16 w-16 items-center justify-center rounded-2xl bg-white text-slate-400 shadow-sm">

//                       {uploading ? (
//                         <Loader2
//                           size={27}
//                           className="animate-spin"
//                         />
//                       ) : (
//                         <ImageIcon
//                           size={27}
//                         />
//                       )}

//                     </div>

//                     <p className="text-sm font-semibold text-slate-700">
//                       {uploading
//                         ? "Uploading image..."
//                         : "Choose image from device"}
//                     </p>

//                     <p className="mt-1 text-xs text-slate-400">
//                       PNG, JPG or WEBP • Maximum 5MB
//                     </p>
//                   </>
//                 )}

//                 <input
//                   type="file"
//                   accept="image/png,image/jpeg,image/webp"
//                   onChange={
//                     handleFileChange
//                   }
//                   disabled={uploading}
//                   className="hidden"
//                 />

//               </label>

//               {selectedFile && (
//                 <div className="mt-2 flex items-center gap-2 text-xs text-slate-500">

//                   <ImageIcon
//                     size={14}
//                   />

//                   <span className="truncate">
//                     {
//                       selectedFile.name
//                     }
//                   </span>

//                   {!uploading &&
//                     form.image && (
//                       <span className="font-medium text-emerald-600">
//                         Uploaded
//                       </span>
//                     )}

//                 </div>
//               )}

//             </div>

//             {/* ==================================================
//                 LINK
//             ================================================== */}

//             <div className="flex flex-col">

//               <label className="mb-2 block text-sm font-semibold text-slate-700">
//                 Registration Link
//               </label>

//               <div className="relative">

//                 <LinkIcon
//                   size={18}
//                   className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400"
//                 />

//                 <input
//                   type="url"
//                   value={form.link}
//                   onChange={(
//                     event
//                   ) =>
//                     setForm(
//                       (
//                         prev: CorporateTrainingForm
//                       ) => ({
//                         ...prev,
//                         link: event
//                           .target
//                           .value,
//                       })
//                     )
//                   }
//                   placeholder="https://example.com/register"
//                   className="h-12 w-full rounded-xl border border-slate-200 bg-white pl-11 pr-4 text-sm text-slate-800 outline-none transition placeholder:text-slate-400 focus:border-blue-500 focus:ring-4 focus:ring-blue-500/10"
//                 />

//               </div>

//               <p className="mt-2 text-xs leading-5 text-slate-400">
//                 Enter the complete URL where users should register for the training session.
//               </p>

//               <div className="flex-1" />

//               {/* Create */}

//               <button
//                 type="submit"
//                 disabled={
//                   loading ||
//                   uploading ||
//                   !form.image
//                 }
//                 className="mt-8 flex h-12 w-full items-center justify-center gap-2 rounded-xl bg-blue-600 px-5 text-sm font-semibold text-white shadow-lg shadow-blue-600/20 transition hover:bg-blue-700 disabled:cursor-not-allowed disabled:bg-slate-300 disabled:shadow-none"
//               >

//                 {loading ? (
//                   <>
//                     <Loader2
//                       size={18}
//                       className="animate-spin"
//                     />

//                     Creating...
//                   </>
//                 ) : (
//                   <>
//                     <Plus size={18} />

//                     Create Training Session
//                   </>
//                 )}

//               </button>

//             </div>

//           </form>

//         </div>

//         {/* ====================================================
//             LIST
//         ==================================================== */}

//         <div className="overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm">

//           {/* Header */}

//           <div className="flex flex-col gap-3 border-b border-slate-100 px-5 py-5 sm:flex-row sm:items-center sm:justify-between sm:px-7">

//             <div>

//               <h2 className="font-semibold text-slate-900">
//                 Training Sessions
//               </h2>

//               <p className="mt-1 text-sm text-slate-500">
//                 {sessions.length} session
//                 {sessions.length !==
//                 1
//                   ? "s"
//                   : ""}{" "}
//                 available
//               </p>

//             </div>

//           </div>

//           {/* Loading */}

//           {fetching ? (
//             <div className="flex min-h-[280px] items-center justify-center">

//               <div className="flex items-center gap-3 text-sm text-slate-500">

//                 <Loader2
//                   size={21}
//                   className="animate-spin"
//                 />

//                 Loading sessions...

//               </div>

//             </div>
//           ) : sessions.length ===
//             0 ? (

//             /* Empty */

//             <div className="flex min-h-[280px] flex-col items-center justify-center px-5 text-center">

//               <div className="mb-4 flex h-16 w-16 items-center justify-center rounded-2xl bg-slate-100 text-slate-400">

//                 <ImageIcon
//                   size={27}
//                 />

//               </div>

//               <h3 className="font-semibold text-slate-800">
//                 No training sessions
//               </h3>

//               <p className="mt-1 max-w-sm text-sm text-slate-500">
//                 Create your first corporate training session using the form above.
//               </p>

//             </div>
//           ) : (

//             /* Table */

//             <div className="overflow-x-auto">

//               <table className="w-full min-w-[800px]">

//                 <thead>

//                   <tr className="border-b border-slate-100 bg-slate-50/70">

//                     <th className="px-5 py-4 text-left text-xs font-semibold uppercase tracking-wider text-slate-500 sm:px-7">
//                       Image
//                     </th>

//                     <th className="px-5 py-4 text-left text-xs font-semibold uppercase tracking-wider text-slate-500">
//                       Registration Link
//                     </th>

//                     <th className="px-5 py-4 text-right text-xs font-semibold uppercase tracking-wider text-slate-500 sm:px-7">
//                       Actions
//                     </th>

//                   </tr>

//                 </thead>

//                 <tbody className="divide-y divide-slate-100">

//                   {sessions.map(
//                     (
//                       session: CorporateTrainingSession
//                     ) => {

//                       const imageUrl =
//                         getImageUrl(
//                           session.image
//                         );

//                       return (
//                         <tr
//                           key={
//                             session._id
//                           }
//                           className="transition hover:bg-slate-50/70"
//                         >

//                           {/* Image */}

//                           <td className="px-5 py-4 sm:px-7">

//                             <div className="h-20 w-32 overflow-hidden rounded-xl border border-slate-200 bg-slate-100">

//                               {imageUrl ? (
//                                 <img
//                                   src={
//                                     imageUrl
//                                   }
//                                   alt="Corporate training"
//                                   className="h-full w-full object-cover"
//                                 />
//                               ) : (
//                                 <div className="flex h-full w-full items-center justify-center text-slate-400">

//                                   <ImageIcon
//                                     size={
//                                       22
//                                     }
//                                   />

//                                 </div>
//                               )}

//                             </div>

//                           </td>

//                           {/* Link */}

//                           <td className="px-5 py-4">

//                             <div className="flex max-w-lg items-center gap-2">

//                               <LinkIcon
//                                 size={
//                                   16
//                                 }
//                                 className="shrink-0 text-slate-400"
//                               />

//                               <a
//                                 href={
//                                   session.link
//                                 }
//                                 target="_blank"
//                                 rel="noopener noreferrer"
//                                 className="truncate text-sm font-medium text-blue-600 hover:underline"
//                               >
//                                 {
//                                   session.link
//                                 }
//                               </a>

//                               <ExternalLink
//                                 size={
//                                   14
//                                 }
//                                 className="shrink-0 text-slate-400"
//                               />

//                             </div>

//                           </td>

//                           {/* Actions */}

//                           <td className="px-5 py-4 sm:px-7">

//                             <div className="flex justify-end gap-2">

//                               {/* Edit */}

//                               <button
//                                 type="button"
//                                 onClick={() =>
//                                   openEditModal(
//                                     session
//                                   )
//                                 }
//                                 className="inline-flex h-9 items-center gap-1.5 rounded-lg border border-slate-200 bg-white px-3 text-sm font-medium text-slate-700 transition hover:bg-slate-50"
//                               >

//                                 <Pencil
//                                   size={
//                                     15
//                                   }
//                                 />

//                                 Edit

//                               </button>

//                               {/* Delete */}

//                               <button
//                                 type="button"
//                                 onClick={() =>
//                                   handleDelete(
//                                     session._id
//                                   )
//                                 }
//                                 disabled={
//                                   deleteId ===
//                                   session._id
//                                 }
//                                 className="inline-flex h-9 items-center gap-1.5 rounded-lg border border-red-200 bg-red-50 px-3 text-sm font-medium text-red-600 transition hover:bg-red-100 disabled:cursor-not-allowed disabled:opacity-60"
//                               >

//                                 {deleteId ===
//                                 session._id ? (
//                                   <Loader2
//                                     size={
//                                       15
//                                     }
//                                     className="animate-spin"
//                                   />
//                                 ) : (
//                                   <Trash2
//                                     size={
//                                       15
//                                     }
//                                   />
//                                 )}

//                                 Delete

//                               </button>

//                             </div>

//                           </td>

//                         </tr>
//                       );
//                     }
//                   )}

//                 </tbody>

//               </table>

//             </div>
//           )}

//         </div>

//       </div>

//       {/* ======================================================
//           EDIT MODAL
//       ====================================================== */}

//       {isModalOpen &&
//         editingSession && (
//           <div
//             className="fixed inset-0 z-[999] flex items-center justify-center bg-slate-900/60 p-4 backdrop-blur-sm"
//             onClick={
//               closeEditModal
//             }
//           >

//             <div
//               className="max-h-[90vh] w-full max-w-2xl overflow-y-auto rounded-2xl bg-white shadow-2xl"
//               onClick={(
//                 event
//               ) =>
//                 event.stopPropagation()
//               }
//             >

//               {/* Header */}

//               <div className="flex items-center justify-between border-b border-slate-100 px-5 py-5 sm:px-7">

//                 <div>

//                   <h2 className="text-lg font-semibold text-slate-900">
//                     Edit Training Session
//                   </h2>

//                   <p className="mt-1 text-sm text-slate-500">
//                     Update the image or registration link.
//                   </p>

//                 </div>

//                 <button
//                   type="button"
//                   onClick={
//                     closeEditModal
//                   }
//                   className="flex h-9 w-9 items-center justify-center rounded-lg text-slate-500 transition hover:bg-slate-100"
//                 >
//                   <X size={19} />
//                 </button>

//               </div>

//               {/* Form */}

//               <form
//                 onSubmit={
//                   handleUpdate
//                 }
//                 className="space-y-6 p-5 sm:p-7"
//               >

//                 {/* Image */}

//                 <div>

//                   <label className="mb-2 block text-sm font-semibold text-slate-700">
//                     Training Image
//                   </label>

//                   <label className="group relative block h-64 cursor-pointer overflow-hidden rounded-2xl border-2 border-dashed border-slate-200 bg-slate-50">

//                     <img
//                       src={getImageUrl(
//                         editingSession.image
//                       )}
//                       alt="Training preview"
//                       className="h-full w-full object-cover"
//                     />

//                     <div className="absolute inset-0 flex items-center justify-center bg-black/50 opacity-0 transition group-hover:opacity-100">

//                       <span className="flex items-center gap-2 rounded-xl bg-white px-5 py-3 text-sm font-semibold text-slate-800 shadow-lg">

//                         <Upload
//                           size={17}
//                         />

//                         Change Image

//                       </span>

//                     </div>

//                     {uploading && (
//                       <div className="absolute inset-0 flex items-center justify-center bg-black/50">

//                         <div className="flex items-center gap-2 rounded-xl bg-white px-5 py-3 text-sm font-semibold text-slate-800">

//                           <Loader2
//                             size={
//                               18
//                             }
//                             className="animate-spin"
//                           />

//                           Uploading...

//                         </div>

//                       </div>
//                     )}

//                     <input
//                       type="file"
//                       accept="image/png,image/jpeg,image/webp"
//                       onChange={
//                         handleEditFileChange
//                       }
//                       disabled={
//                         uploading
//                       }
//                       className="hidden"
//                     />

//                   </label>

//                 </div>

//                 {/* Link */}

//                 <div>

//                   <label className="mb-2 block text-sm font-semibold text-slate-700">
//                     Registration Link
//                   </label>

//                   <div className="relative">

//                     <LinkIcon
//                       size={18}
//                       className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400"
//                     />

//                     <input
//                       type="url"
//                       value={
//                         editingSession.link
//                       }
//                       onChange={(
//                         event
//                       ) =>
//                         setEditingSession(
//                           (
//                             prev: CorporateTrainingSession | null
//                           ) =>
//                             prev
//                               ? {
//                                   ...prev,
//                                   link: event
//                                     .target
//                                     .value,
//                                 }
//                               : null
//                         )
//                       }
//                       placeholder="https://example.com/register"
//                       className="h-12 w-full rounded-xl border border-slate-200 bg-white pl-11 pr-4 text-sm text-slate-800 outline-none transition placeholder:text-slate-400 focus:border-blue-500 focus:ring-4 focus:ring-blue-500/10"
//                     />

//                   </div>

//                 </div>

//                 {/* Buttons */}

//                 <div className="flex flex-col-reverse gap-3 border-t border-slate-100 pt-5 sm:flex-row sm:justify-end">

//                   <button
//                     type="button"
//                     onClick={
//                       closeEditModal
//                     }
//                     className="h-11 rounded-xl border border-slate-200 px-5 text-sm font-medium text-slate-700 transition hover:bg-slate-50"
//                   >
//                     Cancel
//                   </button>

//                   <button
//                     type="submit"
//                     disabled={
//                       loading ||
//                       uploading
//                     }
//                     className="inline-flex h-11 items-center justify-center gap-2 rounded-xl bg-blue-600 px-5 text-sm font-semibold text-white transition hover:bg-blue-700 disabled:cursor-not-allowed disabled:opacity-60"
//                   >

//                     {loading ? (
//                       <>
//                         <Loader2
//                           size={
//                             17
//                           }
//                           className="animate-spin"
//                         />

//                         Updating...
//                       </>
//                     ) : (
//                       <>
//                         <Pencil
//                           size={
//                             17
//                           }
//                         />

//                         Update Session
//                       </>
//                     )}

//                   </button>

//                 </div>

//               </form>

//             </div>

//           </div>
//         )}

//     </div>
//   );
// }


"use client";

import React, {
  ChangeEvent,
  FormEvent,
  useEffect,
  useState,
} from "react";

// ============================================================
// TYPES
// ============================================================

interface CorporateTrainingSession {
  _id: string;
  image: string;
  link: string;
  createdAt?: string;
  updatedAt?: string;
  __v?: number;
}

interface FormData {
  image: string;
  link: string;
}

// ============================================================
// API
// ============================================================

const UPLOAD_API =
  "https://service.ireedindia.com/upload";

const CORPORATE_TRAINING_API =
  "https://service.ireedindia.com/v1/corporate-training";

const IMAGE_BASE_URL =
  "https://service.ireedindia.com/image";

// ============================================================
// DEFAULT FORM
// ============================================================

const initialForm: FormData = {
  image: "",
  link: "",
};

// ============================================================
// COMPONENT
// ============================================================

export default function CorporateTraning() {
  const [form, setForm] =
    useState<FormData>(initialForm);

  const [sessions, setSessions] =
    useState<CorporateTrainingSession[]>(
      []
    );

  const [loading, setLoading] =
    useState<boolean>(false);

  const [uploading, setUploading] =
    useState<boolean>(false);

  const [editingId, setEditingId] =
    useState<string | null>(null);

  const [message, setMessage] =
    useState<string>("");

  const [error, setError] =
    useState<string>("");

  // ==========================================================
  // EXTRACT ONLY FILE NAME
  // ==========================================================

  const getFileName = (
    value: string
  ): string => {
    if (!value) return "";

    const cleanValue =
      value.split("?")[0];

    return cleanValue.substring(
      cleanValue.lastIndexOf("/") + 1
    );
  };

  // ==========================================================
  // IMAGE URL FOR DISPLAY
  //
  // DATABASE:
  // training2.jpg
  //
  // DISPLAY:
  // https://service.ireedindia.com/image/training2.jpg
  // ==========================================================

  const getImageUrl = (
    image: string
  ): string => {
    if (!image) return "";

    const fileName =
      getFileName(image);

    if (!fileName) return "";

    return `${IMAGE_BASE_URL}/${fileName}`;
  };

  // ==========================================================
  // FETCH ALL
  // ==========================================================

  const fetchSessions =
    async (): Promise<void> => {
      try {
        setLoading(true);
        setError("");

        const response =
          await fetch(
            `${CORPORATE_TRAINING_API}/find-all`,
            {
              method: "GET",
              cache: "no-store",
            }
          );

        if (!response.ok) {
          throw new Error(
            `Failed to fetch sessions: ${response.status}`
          );
        }

        const result =
          await response.json();

        console.log(
          "Corporate Training Find All:",
          result
        );

        let data: CorporateTrainingSession[] =
          [];

        if (Array.isArray(result)) {
          data = result;
        } else if (
          Array.isArray(result?.data)
        ) {
          data = result.data;
        } else if (
          Array.isArray(
            result?.sessions
          )
        ) {
          data = result.sessions;
        } else if (
          Array.isArray(
            result?.result
          )
        ) {
          data = result.result;
        }

        setSessions(data);
      } catch (err) {
        console.error(
          "FETCH ERROR:",
          err
        );

        setError(
          err instanceof Error
            ? err.message
            : "Failed to load sessions."
        );
      } finally {
        setLoading(false);
      }
    };

  // ==========================================================
  // INITIAL LOAD
  // ==========================================================

  useEffect(() => {
    fetchSessions();
  }, []);

  // ==========================================================
  // INPUT CHANGE
  // ==========================================================

  const handleInputChange = (
    e: ChangeEvent<HTMLInputElement>
  ) => {
    const {
      name,
      value,
    } = e.target;

    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // ==========================================================
  // IMAGE UPLOAD
  // ==========================================================

  const handleImageUpload = async (
    e: ChangeEvent<HTMLInputElement>
  ): Promise<void> => {
    const file =
      e.target.files?.[0];

    if (!file) return;

    try {
      setUploading(true);
      setError("");
      setMessage("");

      const formData =
        new FormData();

      formData.append(
        "file",
        file
      );

      const response =
        await fetch(
          UPLOAD_API,
          {
            method: "POST",
            body: formData,
          }
        );

      if (!response.ok) {
        throw new Error(
          `Image upload failed: ${response.status}`
        );
      }

      const result =
        await response.json();

      console.log(
        "UPLOAD RESPONSE:",
        result
      );

      // ======================================================
      // HANDLE DIFFERENT UPLOAD RESPONSE FORMATS
      // ======================================================

      let uploadedValue = "";

      if (
        typeof result === "string"
      ) {
        uploadedValue = result;
      } else if (
        result?.url
      ) {
        uploadedValue =
          result.url;
      } else if (
        result?.image
      ) {
        uploadedValue =
          result.image;
      } else if (
        result?.data?.url
      ) {
        uploadedValue =
          result.data.url;
      } else if (
        result?.data?.image
      ) {
        uploadedValue =
          result.data.image;
      } else if (
        result?.filename
      ) {
        uploadedValue =
          result.filename;
      } else if (
        result?.fileName
      ) {
        uploadedValue =
          result.fileName;
      }

      if (!uploadedValue) {
        throw new Error(
          "Upload succeeded but filename was not found."
        );
      }

      // ======================================================
      // VERY IMPORTANT
      //
      // Convert:
      //
      // https://service.ireedindia.com/image/
      // 2026-08-12T09-21-15.953Z-training2.jpg
      //
      // TO:
      //
      // 2026-08-12T09-21-15.953Z-training2.jpg
      // ======================================================

      const fileName =
        getFileName(
          uploadedValue
        );

      setForm((prev) => ({
        ...prev,
        image: fileName,
      }));

      setMessage(
        "Image uploaded successfully."
      );

      console.log(
        "ONLY FILENAME:",
        fileName
      );
    } catch (err) {
      console.error(
        "IMAGE UPLOAD ERROR:",
        err
      );

      setError(
        err instanceof Error
          ? err.message
          : "Image upload failed."
      );
    } finally {
      setUploading(false);

      // Allows selecting same image again
      e.target.value = "";
    }
  };

  // ==========================================================
  // CREATE
  // ==========================================================

  const handleCreate = async (
    e: FormEvent<HTMLFormElement>
  ): Promise<void> => {
    e.preventDefault();

    if (!form.image) {
      setError(
        "Please upload an image."
      );
      return;
    }

    if (!form.link.trim()) {
      setError(
        "Please enter a link."
      );
      return;
    }

    try {
      setLoading(true);
      setError("");
      setMessage("");

      // ======================================================
      // ONLY FILE NAME GOES TO API
      // ======================================================

      const payload = {
        image: getFileName(
          form.image
        ),
        link: form.link.trim(),
      };

      console.log(
        "CREATE PAYLOAD:",
        payload
      );

      const response =
        await fetch(
          `${CORPORATE_TRAINING_API}/create`,
          {
            method: "POST",
            headers: {
              "Content-Type":
                "application/json",
            },
            body: JSON.stringify(
              payload
            ),
          }
        );

      const result =
        await response.json();

      console.log(
        "CREATE RESPONSE:",
        result
      );

      if (!response.ok) {
        throw new Error(
          result?.message ||
          `Create failed: ${response.status}`
        );
      }

      setMessage(
        "Corporate training session created successfully."
      );

      setForm(initialForm);

      await fetchSessions();
    } catch (err) {
      console.error(
        "CREATE ERROR:",
        err
      );

      setError(
        err instanceof Error
          ? err.message
          : "Failed to create session."
      );
    } finally {
      setLoading(false);
    }
  };

  // ==========================================================
  // EDIT
  // ==========================================================

  const handleEdit = (
    session: CorporateTrainingSession
  ): void => {
    setEditingId(
      session._id
    );

    setForm({
      image: getFileName(
        session.image
      ),
      link:
        session.link || "",
    });

    setMessage("");
    setError("");

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  // ==========================================================
  // UPDATE
  // ==========================================================

  const handleUpdate = async (
    e: FormEvent<HTMLFormElement>
  ): Promise<void> => {
    e.preventDefault();

    if (!editingId) return;

    if (!form.image) {
      setError(
        "Please upload an image."
      );
      return;
    }

    if (!form.link.trim()) {
      setError(
        "Please enter a link."
      );
      return;
    }

    try {
      setLoading(true);
      setError("");
      setMessage("");

      const payload = {
        image: getFileName(
          form.image
        ),
        link: form.link.trim(),
      };

      console.log(
        "UPDATE PAYLOAD:",
        payload
      );

      const response =
        await fetch(
          `${CORPORATE_TRAINING_API}/edit/${editingId}`,
          {
            method: "PATCH",
            headers: {
              "Content-Type":
                "application/json",
            },
            body: JSON.stringify(
              payload
            ),
          }
        );

      const result =
        await response.json();

      if (!response.ok) {
        throw new Error(
          result?.message ||
          `Update failed: ${response.status}`
        );
      }

      setMessage(
        "Session updated successfully."
      );

      setEditingId(null);
      setForm(initialForm);

      await fetchSessions();
    } catch (err) {
      console.error(
        "UPDATE ERROR:",
        err
      );

      setError(
        err instanceof Error
          ? err.message
          : "Failed to update session."
      );
    } finally {
      setLoading(false);
    }
  };

  // ==========================================================
  // DELETE
  // ==========================================================

  const handleDelete = async (
    id: string
  ): Promise<void> => {
    const confirmed =
      window.confirm(
        "Are you sure you want to delete this session?"
      );

    if (!confirmed) return;

    try {
      setLoading(true);
      setError("");
      setMessage("");

      const response =
        await fetch(
          `${CORPORATE_TRAINING_API}/delete/${id}`,
          {
            method: "DELETE",
          }
        );

      const result =
        await response.json();

      if (!response.ok) {
        throw new Error(
          result?.message ||
          `Delete failed: ${response.status}`
        );
      }

      setMessage(
        "Session deleted successfully."
      );

      await fetchSessions();
    } catch (err) {
      console.error(
        "DELETE ERROR:",
        err
      );

      setError(
        err instanceof Error
          ? err.message
          : "Failed to delete session."
      );
    } finally {
      setLoading(false);
    }
  };

  // ==========================================================
  // CANCEL EDIT
  // ==========================================================

  const cancelEdit = (): void => {
    setEditingId(null);
    setForm(initialForm);
    setError("");
    setMessage("");
  };

  // ==========================================================
  // JSX
  // ==========================================================

  return (
    <div className="min-h-screen bg-slate-50 p-4 md:p-6 lg:p-8">
      <div className="mx-auto max-w-7xl">

        {/* ==================================================
            HEADER
        ================================================== */}

        <div className="mb-8">
          <h1 className="text-2xl font-bold text-gray-900 md:text-3xl">
            Corporate Training
          </h1>

          <p className="mt-2 text-sm text-gray-500">
            Manage corporate training
            sessions.
          </p>
        </div>

        {/* ==================================================
            SUCCESS
        ================================================== */}

        {message && (
          <div className="mb-5 rounded-lg border border-green-200 bg-green-50 px-4 py-3 text-sm text-green-700">
            {message}
          </div>
        )}

        {/* ==================================================
            ERROR
        ================================================== */}

        {error && (
          <div className="mb-5 rounded-lg border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">
            {error}
          </div>
        )}

        {/* ==================================================
            FORM CARD
        ================================================== */}

        <div className="mb-8 rounded-2xl bg-white p-5 shadow-sm md:p-7">

          <div className="mb-6">
            <h2 className="text-xl font-bold text-gray-900">
              {editingId
                ? "Edit Training Session"
                : "Create Training Session"}
            </h2>

            <p className="mt-1 text-sm text-gray-500">
              Add training image and
              registration link.
            </p>
          </div>

          <form
            onSubmit={
              editingId
                ? handleUpdate
                : handleCreate
            }
            className="space-y-6"
          >

            {/* ==================================================
                IMAGE
            ================================================== */}

            <div>
              <label className="mb-2 block text-sm font-semibold text-gray-700">
                Training Image
              </label>

              <input
                type="file"
                accept="image/*"
                disabled={uploading}
                onChange={
                  handleImageUpload
                }
                className="block w-full cursor-pointer rounded-lg border border-gray-300 bg-white text-sm text-gray-700 file:mr-4 file:border-0 file:bg-blue-50 file:px-4 file:py-3 file:text-sm file:font-semibold file:text-blue-700 hover:file:bg-blue-100"
              />

              {uploading && (
                <p className="mt-2 text-sm text-blue-600">
                  Uploading image...
                </p>
              )}

              {/* ============================================
                  ONLY FILE NAME
              ============================================ */}

              {form.image && (
                <div className="mt-3 rounded-lg bg-gray-50 p-3">
                  <p className="text-xs font-semibold text-gray-500">
                    Stored filename
                  </p>

                  <p className="mt-1 break-all text-sm text-gray-700">
                    {getFileName(
                      form.image
                    )}
                  </p>
                </div>
              )}

              {/* ============================================
                  PREVIEW
              ============================================ */}

              {form.image && (
                <div className="mt-4">
                  <p className="mb-2 text-sm font-semibold text-gray-700">
                    Preview
                  </p>

                  <img
                    src={getImageUrl(
                      form.image
                    )}
                    alt="Training Preview"
                    className="h-40 w-64 rounded-lg border border-gray-200 object-cover shadow-sm"
                  />
                </div>
              )}
            </div>

            {/* ==================================================
                LINK
            ================================================== */}

            <div>
              <label className="mb-2 block text-sm font-semibold text-gray-700">
                Link
              </label>

              <input
                type="url"
                name="link"
                value={form.link}
                onChange={
                  handleInputChange
                }
                placeholder="https://www.linkedin.com/..."
                className="w-full rounded-lg border border-gray-300 px-4 py-3 text-sm text-gray-800 outline-none transition focus:border-blue-500 focus:ring-2 focus:ring-blue-100"
              />
            </div>

            {/* ==================================================
                BUTTONS
            ================================================== */}

            <div className="flex flex-wrap gap-3">

              <button
                type="submit"
                disabled={
                  loading ||
                  uploading
                }
                className="rounded-lg bg-blue-600 px-6 py-3 text-sm font-semibold text-white transition hover:bg-blue-700 disabled:cursor-not-allowed disabled:opacity-50"
              >
                {loading
                  ? editingId
                    ? "Updating..."
                    : "Creating..."
                  : editingId
                    ? "Update Session"
                    : "Create Session"}
              </button>

              {editingId && (
                <button
                  type="button"
                  onClick={
                    cancelEdit
                  }
                  className="rounded-lg border border-gray-300 bg-white px-6 py-3 text-sm font-semibold text-gray-700 transition hover:bg-gray-50"
                >
                  Cancel
                </button>
              )}
            </div>
          </form>
        </div>

        {/* ==================================================
            ALL SESSIONS
        ================================================== */}

        <div>

          <div className="mb-5 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">

            <div>
              <h2 className="text-xl font-bold text-gray-900">
                All Training Sessions
              </h2>

              <p className="mt-1 text-sm text-gray-500">
                {sessions.length}{" "}
                session
                {sessions.length !==
                  1
                  ? "s"
                  : ""}
              </p>
            </div>

            <button
              type="button"
              onClick={
                fetchSessions
              }
              disabled={loading}
              className="w-fit rounded-lg border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-50"
            >
              Refresh
            </button>
          </div>

          {/* ==================================================
              LOADING
          ================================================== */}

          {loading &&
            sessions.length === 0 ? (
            <div className="rounded-xl bg-white py-16 text-center shadow-sm">
              <p className="text-sm text-gray-500">
                Loading sessions...
              </p>
            </div>
          ) : sessions.length ===
            0 ? (
            <div className="rounded-xl bg-white py-16 text-center shadow-sm">
              <p className="text-sm text-gray-500">
                No corporate training
                sessions found.
              </p>
            </div>
          ) : (

            /* ==================================================
                SESSION GRID
            ================================================== */

            <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">

              {sessions.map(
                (session) => (
                  <div
                    key={
                      session._id
                    }
                    className="group overflow-hidden rounded-xl bg-white shadow-sm transition duration-300 hover:-translate-y-1 hover:shadow-lg"
                  >

                    {/* IMAGE */}

                    <div className="relative h-48 overflow-hidden bg-gray-100">

                      <img
                        src={getImageUrl(
                          session.image
                        )}
                        alt="Corporate Training"
                        className="h-full w-full object-cover transition duration-300 group-hover:scale-105"
                      />

                    </div>

                    {/* CONTENT */}

                    <div className="p-4">

                      {/* FILE NAME */}

                      <p className="mb-2 break-all text-xs text-gray-500">
                        {getFileName(
                          session.image
                        )}
                      </p>

                      {/* LINK */}

                      <a
                        href={
                          session.link
                        }
                        target="_blank"
                        rel="noopener noreferrer"
                        className="mb-4 block truncate text-sm font-medium text-blue-600 hover:text-blue-800 hover:underline"
                      >
                        {session.link}
                      </a>

                      {/* ACTIONS */}

                      <div className="flex gap-2">

                        <button
                          type="button"
                          onClick={() =>
                            handleEdit(
                              session
                            )
                          }
                          className="flex-1 rounded-lg border border-blue-600 px-3 py-2 text-sm font-semibold text-blue-600 transition hover:bg-blue-50"
                        >
                          Edit
                        </button>

                        <button
                          type="button"
                          onClick={() =>
                            handleDelete(
                              session._id
                            )
                          }
                          className="flex-1 rounded-lg border border-red-500 px-3 py-2 text-sm font-semibold text-red-500 transition hover:bg-red-50"
                        >
                          Delete
                        </button>

                      </div>
                    </div>
                  </div>
                )
              )}

            </div>
          )}
        </div>
      </div>
    </div>
  );
}